import { Button } from "@gigpro/ui/Button";
import { Dialog, DialogFooter, DialogTitle } from "@gigpro/ui/Dialog";
import type { ForManagerLocationDetail } from "@sidegigllc/api/client";
import { Link } from "@tanstack/react-router";
import type { LocationSummary } from "api/resources/StafferGig";
import { useActiveLocation } from "services/locationOrgContext";
import type { ModalBaseProps } from "types/utils";
import { MoneyExchange } from "./MoneyExchange";

interface BillingDialogProps extends ModalBaseProps {
  location?: LocationSummary | ForManagerLocationDetail;
}

export const useBillingPath = (location?: LocationSummary | ForManagerLocationDetail) => {
  const [activeLocation] = useActiveLocation();
  const billingLocation = location ?? activeLocation;

  if (billingLocation.billing_source === "ORGANIZATION") {
    return `/organizations/${billingLocation.organization_id}/billing`;
  }
  return `/locations/${billingLocation.id}/billing`;
};

export function BillingSetupRequiredDialog({ open, onClose, location }: Readonly<BillingDialogProps>) {
  const billingPath = useBillingPath(location);
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle />
      <MoneyExchange className="mx-auto mb-4 size-24" />
      <h1 className="mb-2 text-extraLarge font-semibold">Setup your Stripe account</h1>
      <p className="text-large">
        We use Stripe to process payments and pay out earnings for working interviews. By connecting your card or bank
        account, you're agreeing to Stripe's Terms of Service.
        <br />
        <br />
        Link your credit/debit card or bank account in order to pay candidates.
      </p>
      <DialogFooter>
        <Button asChild size="small" variant="contained">
          <Link to={billingPath}>Setup Stripe</Link>
        </Button>
      </DialogFooter>
    </Dialog>
  );
}

export function BankAccountPendingDialog({ open, onClose, location }: Readonly<BillingDialogProps>) {
  const billingPath = useBillingPath(location);
  return (
    <Dialog open={open} onClose={onClose}>
      <MoneyExchange className="mx-auto mb-4 size-24" />
      <h1 className="mb-2 text-extraLarge font-semibold">Add a Credit Card</h1>
      <p className="text-large">
        Your bank account is still pending, add a Credit Card to select and pay candidates in the meantime.
      </p>
      <p className="text-large">
        We use Stripe to process payments and pay out earnings for working interviews. By connecting your card or bank
        account, you're agreeing to Stripe's Terms Of Service.
      </p>
      <DialogFooter>
        <Button asChild size="small" variant="contained">
          <Link to={billingPath}>Add credit card</Link>
        </Button>
      </DialogFooter>
    </Dialog>
  );
}
